<template>
    <form action="" method="post" enctype="multipart/form-data" class="logo_file mt-4" >
        <input type="file" name="files" ref="file" class="files"  
            :data-fileuploader-files='ploadlogo'
            />
    </form>
</template>

<script>
    export default {
        props: ['ploadlogo'],
        data() {
            return {
                file: null,
            }
        },
        methods: {
            sendData(){
                this.$emit('data', this.file);
            }
        },
        mounted () {
            var t = this
            $(document).ready(function() {
                $.ajaxSetup({
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
                    }
                });
                $(".logo_file input.files").fileuploader({
                    limit: 1,
                    extensions: ["jpg", "png", "svg"],
                    fileMaxSize: 2,
                    changeInput:
                                '<div class="fileuploader-input">' +
                                '<div class="fileuploader-input-inner">' +
                                '<div class="fileuploader-icon-main"></div>' +
                                '<h3 class="fileuploader-input-caption"><span>${captions.feedback}</span></h3>' +
                                "<p>${captions.or}</p>" +
                                '<button type="button" class="fileuploader-input-button"><span>${captions.button}</span></button>' +
                                "</div>" +
                                "</div>",
                    theme: "dragdrop",
                    thumbnails: {
                        onImageLoaded: function(item) {
                            t.file = item.file
                            if (!item.html.find(".fileuploader-action-edit").length)
                                item.html
                                    .find(".fileuploader-action-remove")
                                    .before(
                                        '<button type="button" class="fileuploader-action fileuploader-action-popup fileuploader-action-edit" title="Uraviť">' +
                                            '<i class="fileuploader-icon-edit"></i></button>'
                                    );

                            // hide current thumbnail (this is only animation)
                            if (item.imageIsUploading) {
                                item.image.addClass("fileuploader-loading").html("");
                            }
                            t.sendData()
                        },
                    },
                    editor: {
                        cropper: {
                            showGrid: true
                        }
                    },
                    captions: $.extend(true, {}, $.fn.fileuploader.languages["en"], {
                        feedback: t.$t('company.logo_text_1'),
                        feedback2: t.$t('company.logo_text_2'),
                        drop: t.$t('company.logo_text_3'),
                        or: t.$t('company.logo_text_4'),
                        button: t.$t('company.logo_text_5'),
                        remove: t.$t('company.logo_text_6'),
                        download: t.$t('company.logo_text_7'),
                        removeConfirmation: t.$t('company.logo_text_8'),
                        errors: {
                            filesLimit: function(e) {
                                    t.$toast.warning(t.$t('company.logo_text_9'), {
                                        timeout: 5000,
                                    })
                            },
                            filesType: function(e) {
                                    t.$toast.warning(t.$t('company.logo_text_10', { extensions: e.extensions }), {
                                        timeout: 5000,
                                    })
                            },
                            fileSize: function(e) {
                                    t.$toast.warning(t.$t('company.logo_text_11', { name: e.name, fileMaxSize: e.fileMaxSize }), {
                                        timeout: 5000,
                                    })
                            }
                        }
                    }),

                    onRemove: function(item) {
                        t.file = null
                        axios.post('/api/firma/logo/remove', { file: item.name, type: 0 })
                        t.sendData()
                    },

                });
            })
        },
        
    }

</script>

<style lang="scss" scoped>
    form{
        width: 430px;
        margin: 0 auto;
        @media only screen and (max-width: 600px) {
            width: 95%;
        }
    }
</style>